import { useWeb3React } from '@web3-react/core'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { CURRENCY_LIST, LOCALIZATION_LIST } from 'config/constants'
import { useTranslation } from 'contexts/Localization'
import { Switch } from 'antd'
import { useRouter } from 'next/router'
import { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrency } from 'state/app/actions'
import styled from 'styled-components'
import { Flex, Link } from 'widgets'
import { getContactContentChat } from 'hooks/getContactContentChat'
import { defaultSocialData } from 'components/Footer'
import { Language } from '../../../packages/uikit/src/widgets/Menu'
import { menuItems } from './config'
import { MenuEntry as MenuEntryTypes } from './types'

const Wrapper = styled.div<{ visible: boolean }>`
  position: fixed;
  width: 100vw;
  height: 100vh;
  padding: 90px 0;
  z-index: 900;
  overflow: auto;
  transition: 0.25s;
  transform: ${({ visible }) => (visible ? 'translateX(0)' : 'translateX(100%)')};
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  background: #fff;
`

const MenuActionsMobile = styled.div`
  margin-top: 30px;
  position: relative;
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  .menu-mobile-items {
    padding: 12px 24px;
    cursor: pointer;
    align-items: center;
    .menu-mobile-item-left {
      gap: 12px;
      align-items: center;
      span {
        font-size: 18px;
      }
      a {
        display: flex;
        gap: 12px;
        align-items: center;
      }
    }
    .menu-mobile-item-right {
      img {
        height: 30px;
      }
      span {
        font-size: 13px;
        text-align: center;
        margin: auto 8px;
        text-transform: uppercase;
      }
    }
    .menu-mobile-language-item {
      .menu-mobile-item-right {
        span {
          min-width: 100px;
        }
      }
    }
  }
  .menu-mobile-item-connect {
    padding: 12px 24px 24px 24px;
  }
  .social-network {
    padding: 0 24px;
    .social-network-item {
      display: flex;
      justify-content: center;
      gap: 18px;
      cursor: pointer;
      img:hover {
        opacity: 0.8;
      }
    }
    .social-network-item-top {
      padding: 36px 0 12px 0;
      border-top: 2px solid rgba(109, 109, 109, 0.5); /* Đặt border top màu xám */
    }
  }

  .menu-mobile-language-item,
  .menu-mobile-fiat-item {
    font-size: 18px;
    .menu-mobile-item-right {
      display: flex;
      width: 30%;
      justify-content: space-between;
      align-items: center;
      img {
        width: 13px;
        display: none;
      }
      span {
        font-size: 20px;
        font-weight: 400;
        color: #6d6d6d;
      }
    }
    .menu-mobile-item-left {
      width: 70%;
      margin-left: 42px;
      align-items: center;
      img {
        height: 30px;
      }
      .light {
        display: none;
      }
    }
  }
  .active {
    span {
      color: #006dfe;
    }
    .menu-mobile-item-right {
      img {
        display: block;
      }
    }
  }

  .menu-mobile-items:hover {
    background: #f5f5f5;
    .light {
      display: block;
    }
    .dark {
      display: none;
    }
  }

  .open-app-btn {
    margin-top: 2rem;
    border-radius: 30px;
    width: 100%;
    text-transform: uppercase;
  }

  .menu-mobile-stats {
    cursor: pointer;
  }

  @media (max-width: 572px) {
    .menu-mobile-language-item {
      .menu-mobile-item-left {
        width: 80%;
      }
    }
  }
`

interface Props {
  visible: boolean
  links: MenuEntryTypes[]
  accountEllipsis?: string
  toggleWallet?: () => void
  toggleMenu: () => void
}
interface Currency {
  flag: string
  name: string
  abbreviation: string
  symbol: string
  icon: string // Thêm trường "icon" vào kiểu dữ liệu của phần tử trong mảng
}

interface LanguageFormat {
  flag: string
  lang: string
  icon: string // Thêm trường "icon" vào kiểu dữ liệu của phần tử trong mảng
}

// Replace the existing iconsSocial constant with this:
const topIcons = [
  { type: 'TelegramChannel', icon: '/images/icons/icon-tele.svg' },
  { type: 'Mirror', icon: '/images/icons/icon-medium.svg' },
  { type: 'TelegramGroup', icon: '/images/icons/icon-tele-1.svg' },
  { type: 'Twitter', icon: '/images/icons/icon-twitter.svg' },
  { type: 'Linkedin', icon: '/images/icons/icon-lin.svg' },
]

const bottomIcons = [
  { type: 'Discord', icon: '/images/icons/icon-disc.svg' },
  { type: 'Youtube', icon: '/images/icons/icon-ytb.svg' },
  { type: 'Instagram', icon: '/images/icons/icon-ins.svg' },
]

interface SocialMediaItem {
  link: string
  type: string
  icon: string
}

const transformSocialData = (data: SocialMediaItem[]) => {
  return data.reduce(
    (acc, item) => ({
      ...acc,
      [item.type]: item.link,
    }),
    {},
  )
}

interface SocialMediaLinks {
  [key: string]: string
}

const MobileSlider = ({ visible, links, toggleMenu }: Props) => {
  const [openLanguage, setOpenLanguage] = useState<boolean>(false)
  const { account } = useWeb3React()
  const { isLogin } = useSelector((state: any) => state.auth)

  const [openFiat, setOpenFiat] = useState<boolean>(false)
  const [openExplorer, setOpenExplorer] = useState<boolean>(false)

  const [isTypeLanguage, setIsTypeLanguage] = useState<string>('EN')
  const [isTypeCurrency, setIsTypeCurrency] = useState<string>('USD')
  const [checkedMode, setCheckedMode] = useState(false)

  const [listCurrency, setListCurrency] = useState<Currency[]>([])
  const [listLanguage, setListLanguage] = useState<LanguageFormat[]>([])

  const [iconCurrency, setIconCurrency] = useState<string>('/images/icons/usd.svg')
  const [iconLanguage, setIconLanguage] = useState<string>('/images/icons/flag_usa.svg')
  const [socialLinks, setSocialLinks] = useState<SocialMediaLinks>({})

  useEffect(() => {
    const getData = async () => {
      const data = await getContactContentChat()
      setSocialLinks(transformSocialData(data || defaultSocialData))
    }

    getData()
  }, [])

  const router = useRouter()
  const { t, setLanguage } = useTranslation()
  const dispatch = useDispatch()

  // update google translate selector
  const onChangeLocalize = (flag) => {
    const localize = LOCALIZATION_LIST.filter((x) => x.flag === flag)
    localStorage.setItem('localize', JSON.stringify(localize[0]))
    const dataLanguage = {
      code: localize[0].lang,
      language: localize[0].lang,
      locale: localize[0].lang,
    } as Language

    setLanguage(dataLanguage)
  }

  useMemo(() => {
    const cacheLocalize = localStorage.getItem('localize')
    let _flag = LOCALIZATION_LIST[0].flag
    if (cacheLocalize) {
      const jsonLocalize = JSON.parse(cacheLocalize)
      _flag = jsonLocalize ? jsonLocalize.flag : LOCALIZATION_LIST[0].flag
    }
    setIsTypeLanguage(_flag)
  }, [])

  useEffect(() => {
    if (localStorage.getItem('currency')) {
      setIsTypeCurrency(localStorage.getItem('currency'))
      dispatch(setCurrency(localStorage.getItem('currency')))
    } else {
      setIsTypeCurrency(CURRENCY_LIST[0].flag)
    }
  }, [dispatch])

  // update currency selector
  const onChangeLocalizeCurrency = (flag) => {
    localStorage.setItem('currency', flag)
    dispatch(setCurrency(flag))
  }

  useEffect(() => {
    let formatListCurrency: Currency[] = []

    let formatListLanguage: LanguageFormat[] = []

    formatListCurrency = CURRENCY_LIST?.map((currency) => {
      let icon = '/images/icons/usd.svg' // Biểu tượng mặc định

      switch (currency.flag) {
        case 'US':
          icon = '/images/icons/usd.svg'
          break
        case 'VN':
          icon = '/images/icons/vnd.svg'
          break
        case 'BG':
          icon = '/images/icons/euro.svg'
          break
        default:
          break
      }

      return { ...currency, icon } // Trả về đối tượng với giá trị icon đã cập nhật
    })

    formatListLanguage = LOCALIZATION_LIST?.map((language) => {
      let icon = '/images/icons/flag_usa.svg' // Biểu tượng mặc định
      let lang = 'English' // Ngôn ngữ mặc định

      switch (language.flag) {
        case 'US':
          icon = '/images/icons/flag_usa.svg'
          lang = 'English'
          break
        case 'VN':
          icon = '/images/icons/flag_vn.svg'
          lang = 'Tiếng Việt'
          break
        case 'CN':
          icon = '/images/icons/flag_cn.svg'
          lang = 'Chinese'
          break
        default:
          break
      }

      return { ...language, icon, lang } // Trả về đối tượng với giá trị icon và lang đã cập nhật
    })

    setListCurrency(formatListCurrency)
    setListLanguage(formatListLanguage)
  }, [])

  useEffect(() => {
    const current = listCurrency?.find((obj) => obj?.flag === isTypeCurrency)
    setIconCurrency(current?.icon ? current?.icon : '/images/icons/usd.svg')
  }, [isTypeCurrency, listCurrency])

  useEffect(() => {
    const language = listLanguage?.find((obj) => obj?.flag === isTypeLanguage)
    setIconLanguage(language?.icon ? language?.icon : '/images/icons/flag_usa.svg')
  }, [isTypeLanguage, listLanguage])
  return (
    <Wrapper visible={visible}>
      <MenuActionsMobile>
        <div className="menu-mobile-items menu-mobile-stats">
          <Flex className="menu-mobile-item-left">
            <img src="/images/icons/search-exchange.svg" alt="" />
            <span>Stats</span>
          </Flex>
        </div>
        <div
          className="menu-mobile-items menu-mobile-language"
          onClick={() => setOpenLanguage(!openLanguage)}
          aria-hidden="true"
        >
          <Flex className="item-left" justifyContent="space-between">
            <Flex className="menu-mobile-item-left">
              {openLanguage ? (
                <img src="/images/icons/icon-language-blue.svg" alt="" />
              ) : (
                <img src="/images/icons/icon-language.svg" alt="" />
              )}

              <span>{t('Ngôn ngữ')}</span>
            </Flex>
            <Flex className="menu-mobile-item-right">
              <img src={iconLanguage} alt="flag_vn.svg" />
              <span>{isTypeLanguage}</span>
              {openLanguage ? (
                <img
                  src="/images/icons/icon-arrow-top.svg"
                  alt="icon-arrow-top.svg"
                  style={{ height: '13px', width: '13px', margin: 'auto', cursor: 'pointer' }}
                />
              ) : (
                <img
                  src="/images/icons/icon-arrow-right.svg"
                  alt="icon-arrow-right.svg"
                  style={{ height: '13px', width: '13px', margin: 'auto', cursor: 'pointer' }}
                />
              )}
            </Flex>
          </Flex>
        </div>

        {openLanguage && (
          <div>
            {listLanguage?.length > 0 &&
              listLanguage?.map((language) => {
                return (
                  <Flex
                    className={
                      isTypeLanguage === language.flag
                        ? 'menu-mobile-items menu-mobile-language-item active'
                        : 'menu-mobile-items menu-mobile-language-item '
                    }
                    onClick={() => {
                      setIsTypeLanguage(language?.flag)
                      onChangeLocalize(language?.flag)
                    }}
                  >
                    <Flex className="menu-mobile-item-left">
                      <img src={language?.icon} alt="flag_vn.svg" />
                      <span>{language?.lang}</span>
                    </Flex>
                    <Flex className=" menu-mobile-item-right">
                      <span>{language?.flag}</span>
                      <img
                        src="/images/icons/icon-dot.svg"
                        alt="icon-dot.svg"
                        style={{ height: '10px', cursor: 'pointer' }}
                      />
                    </Flex>
                  </Flex>
                )
              })}
          </div>
        )}

        <div className="menu-mobile-items menu-mobile-fiat " onClick={() => setOpenFiat(!openFiat)} aria-hidden="true">
          <Flex className="item-left" justifyContent="space-between">
            <Flex className="menu-mobile-item-left">
              {openFiat ? (
                <img src="/images/icons/icon-fiat-blue.svg" alt="" />
              ) : (
                <img src="/images/icons/icon-fiat.svg" alt="" />
              )}

              <span>{t('Tiền tệ')}</span>
            </Flex>

            <Flex className="menu-mobile-item-right">
              <img src={iconCurrency} alt="flag_usa.svg" />
              <span>{isTypeCurrency}</span>
              {openFiat ? (
                <img
                  src="/images/icons/icon-arrow-top.svg"
                  alt="icon-arrow-top.svg"
                  style={{ height: '13px', width: '13px', margin: 'auto', cursor: 'pointer' }}
                />
              ) : (
                <img
                  src="/images/icons/icon-arrow-right.svg"
                  alt="icon-arrow-right.svg"
                  style={{ height: '13px', width: '13px', margin: 'auto', cursor: 'pointer' }}
                />
              )}
            </Flex>
          </Flex>
        </div>
        {openFiat && (
          <div>
            {listCurrency?.length > 0 &&
              listCurrency?.map((currency) => {
                return (
                  <Flex
                    className={
                      isTypeCurrency === currency.abbreviation
                        ? 'menu-mobile-items menu-mobile-fiat-item active'
                        : 'menu-mobile-items menu-mobile-fiat-item  '
                    }
                    onClick={() => {
                      setIsTypeCurrency(currency.abbreviation)
                      onChangeLocalizeCurrency(currency.flag)
                    }}
                  >
                    <Flex className="menu-mobile-item-left">
                      <img src={currency?.icon} alt="flag_usa.svg" />
                      <span>{currency?.name}</span>
                    </Flex>
                    <Flex className="menu-mobile-item-right  ">
                      <span>
                        {currency?.abbreviation} - {currency?.symbol}
                      </span>
                      <img
                        src="/images/icons/icon-dot.svg"
                        alt="icon-dot.svg"
                        style={{ height: '10px', cursor: 'pointer' }}
                      />
                    </Flex>
                  </Flex>
                )
              })}
          </div>
        )}

        <div
          className="menu-mobile-items menu-mobile-explore"
          onClick={() => setOpenExplorer(!openExplorer)}
          aria-hidden="true"
        >
          <Flex className="item-left" justifyContent="space-between">
            <Flex className="menu-mobile-item-left">
              <img src="/images/icons/icon-explore.svg" alt="" />
              <span>{t('Khám phá')}</span>
            </Flex>

            <Flex className="menu-mobile-item-right">
              {openExplorer ? (
                <img
                  src="/images/icons/icon-arrow-top.svg"
                  alt="icon-arrow-top.svg"
                  style={{ height: '13px', width: '13px', margin: 'auto', cursor: 'pointer' }}
                />
              ) : (
                <img
                  src="/images/icons/icon-arrow-right.svg"
                  alt="icon-arrow-right.svg"
                  style={{ height: '13px', width: '13px', margin: 'auto', cursor: 'pointer' }}
                />
              )}
            </Flex>
          </Flex>
        </div>
        {openExplorer && (
          <div>
            {menuItems[0]?.items?.map((item) => {
              return (
                <Flex className="menu-mobile-items menu-mobile-language-item " style={{ width: '80%' }}>
                  <Flex className="menu-mobile-item-left">
                    <Link href={item?.href}>
                      <img className="dark" src={`/images/icons/${item?.icon}`} alt={`/images/icons/${item?.icon}`} />
                      <img
                        className="light"
                        src={`/images/icons/${item?.iconLight}`}
                        alt={`/images/icons/${item?.iconLight}`}
                      />
                      <span>{item?.label}</span>
                    </Link>
                  </Flex>
                </Flex>
              )
            })}
          </div>
        )}
        {/* <div className="menu-mobile-items menu-mobile-mode">
          <Flex className="item-left" justifyContent="space-between">
            <Flex className="menu-mobile-item-left">
              <img src="/images/icons/icon-mode.svg" alt="" />
              <span>Light - Dark Mode</span>
            </Flex>
            <Flex>
              <Switch
                checkedChildren={<img className="light-mode" src="/images/account/icons/light.svg" alt="" />}
                unCheckedChildren={<img className="dark-mode" src="/images/account/icons/dark.svg" alt="" />}
                checked={checkedMode}
                onChange={(e) => setCheckedMode(e)}
              />
            </Flex>
          </Flex>
        </div> */}
        {!account && !isLogin && (
          <div className="menu-mobile-item-connect">
            <ConnectWalletButton className="open-app-btn" style={{ marginBottom: '15px' }} />
          </div>
        )}

        <div className="social-network">
          <div className="social-network-item social-network-item-top">
            {topIcons.map((social) => (
              <a key={social.type} href={socialLinks[social.type]} target="_blank" rel="noreferrer">
                <img src={social.icon} alt={social.type} />
              </a>
            ))}
          </div>
          <div className="social-network-item">
            {bottomIcons.map((social) => (
              <a key={social.type} href={socialLinks[social.type]} target="_blank" rel="noreferrer">
                <img src={social.icon} alt={social.type} />
              </a>
            ))}
          </div>
        </div>
      </MenuActionsMobile>
    </Wrapper>
  )
}
export default MobileSlider
